import React, { useState, FC } from 'react';
import Tooltip, { THEME } from '@mos-cat/tooltip';

import happy from '@assets/happy.svg';
import indifferent from '@assets/indifferent.svg';
import sad from '@assets/sad.svg';

import st from './Rating.module.css';

const getRatingOptions = rating => {
  if (rating > 75) {
    return {
      component: happy,
      color: '#229922',
    };
  }

  if (rating > 50) {
    return {
      component: indifferent,
      color: '#FFAA00',
    };
  }

  return {
    component: sad,
    color: '#CC2222',
  };
};

type RatingProps = {
  isDetailed?: boolean;
  rating: number;
};

const Rating: FC<RatingProps> = ({ isDetailed = false, rating }) => {
  const [open, setOpen] = useState(false);
  const ratingOptions = getRatingOptions(rating);

  return (
    <Tooltip
      wrapperClassName={st.popover}
      considerHeader
      floating
      theme={THEME.HINT}
      open={open}
      content="Рейтинг за всё время"
    >
      <div
        className={isDetailed ? st.ratingContainerBig : st.ratingContainer}
        onMouseOver={() => setOpen(true)}
        onMouseOut={() => setOpen(null)}
        onFocus={() => setOpen(null)}
        onBlur={() => setOpen(null)}
      >
        <div
          className={st.ratingSmileContainer}
          style={{ backgroundColor: ratingOptions.color }}
        >
          <img
            className={st.ratingSmile}
            src={ratingOptions.component}
            alt="Rating"
          />
        </div>
        <span className={st.ratingNumber}>{`${rating}%`}</span>
      </div>
    </Tooltip>
  );
};

export default Rating;
